export interface LpDetailsCompositionItem {
    id: number;
    symbol: string;
    balance: bigint;
    entryValue: bigint;
    rate: number;
    portfolioValue: number;
    unrealisedPnl: number;
    unrealisedPnlPercent: number;
    counterparty: string;
}

export interface LpMock {
    portfolioValue: bigint;
    totalValueLocked: bigint;
    upnlPercent: number;
    userPortfolio: bigint;
    userPnlPercent: number;
    userPnl: bigint;
    composition: LpDetailsCompositionItem[];
}

export const LP_MOCK: LpMock = {
    portfolioValue: 32_820_784_33n, // .2
    totalValueLocked: 35_176_540_33n, // .2
    upnlPercent: 12.32,

    userPortfolio: 13_324_04n, // .2
    userPnlPercent: -8.93,
    userPnl: -2_642_30n, // .2

    composition: [
        {
            id: 345345,
            symbol: 'BTC-USD-PERP',
            balance: 21_61n,
            entryValue: 20_500_00n, // .2
            rate: 118_007.45,
            portfolioValue: 255_015.28,
            unrealisedPnl: 50_015.2775,
            unrealisedPnlPercent: 24.3977,
            counterparty: '0x2E85f1bCD1a9E3F4a7b8cf2a3b4c5d6e7f8a9b0c'
        },
        {
            id: 345346,
            symbol: 'TSLA-USD-PERP',
            balance: 11_286_90n,
            entryValue: 2_645_245_53n, //.2
            rate: 315.46,
            portfolioValue: 3_560_564.65,
            unrealisedPnl: 915_319.1150,
            unrealisedPnlPercent: 34.6024,
            counterparty: '0xF50e17944b4a390034064D5B2cbaAc2E97239daa'
        },
        {
            id: 345347,
            symbol: 'MSTR-USD-PERP',
            balance: 2_003_05n,
            entryValue: 635_045_33n, // .2
            rate: 300.33,
            portfolioValue: 601_575.45,
            unrealisedPnl: -33_469.8800,
            unrealisedPnlPercent: -5.2705,
            counterparty: '0x0339f20069C4f957429816EedDca14dFf0D3aBBc'
        },
        {
            id: 345348,
            symbol: 'XAU-USD-PERP',
            balance: 505_23n,
            entryValue: 169_356_47n, // .2
            rate: 3_464.66,
            portfolioValue: 175_046.33,
            unrealisedPnl: 5_689.8600,
            unrealisedPnlPercent: 3.3597,
            counterparty: '0x09B667280a67dF94E76920B0544739427557EF6F'
        },
        {
            id: 345349,
            symbol: 'BTC-USD-PERP',
            balance: 31_97n,
            entryValue: 43_231_10n, // .2
            rate: 11_576.55,
            portfolioValue: 37_005.34,
            unrealisedPnl: -6_225.7600,
            unrealisedPnlPercent: -14.4011,
            counterparty: '0xDA6817855A5487753ada68C807c04DB9b629D392'
        },
        {
            id: 345332,
            symbol: 'BTC-USD-PERP',
            balance: 3_136_86n,
            entryValue: 3_167_492_44n, // .2
            rate: 11_601.45,
            portfolioValue: 3_639_211.84,
            unrealisedPnl: 471_719.4070,
            unrealisedPnlPercent: 14.8925,
            counterparty: '0xe43b2b6aDC646c6EA8188b17cB2eaD4771831C47'
        },
        {
            id: 345333,
            symbol: 'NVDA-USD-PERP',
            balance: 1_332_83n,
            entryValue: 535_298_71n, // .2
            rate: 401.43,
            portfolioValue: 535_039.86,
            unrealisedPnl: -258.8500,
            unrealisedPnlPercent: -0.0484,
            counterparty: '0x816D5526FaA429DBB88afE99A22815d1C4832c3f'
        }
    ]
};
